export default __webpack_public_path__ + "static/media/i236hk.3e6adeab.webp";